import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { IBarChart } from './BarChart.interface';

export const BarChart: React.FC<IBarChart> = ({
  data,
  height,
  width,
  legend,
  layout = 'vertical',
  indexBy = 'id',
  keys = ['value'],
  colorPalette = 'sequential'
}) => {
  let colors: string[];

  if (keys?.length === 1) {
    colors = ['var(--color-primary-data-blue)'];
  } else if (colorPalette === 'sequential') {
    if (keys.length === 3) {
      colors = [
        'var(--color-primary-data-dark-blue)',
        'var(--color-primary-data-blue)',
        'var(--color-primary-data-sky-blue)'
      ];
    } else {
      colors = [
        'var(--color-primary-data-blue)',
        'var(--color-primary-data-sky-blue)'
      ];
    }
  } else {
    colors = [
      'var(--color-primary-data-sky-blue)',
      'var(--color-secondary-data-fraise)',
      'var(--color-secondary-data-teal)',
      'var(--color-secondary-data-orange)',
      'var(--color-primary-data-blue)',
      'var(--color-secondary-data-moss)',
      'var(--color-secondary-data-lilac)',
      'var(--color-secondary-data-lemon)',
      'var(--color-secondary-data-azur)',
      'var(--color-secondary-data-mint)',
      'var(--color-secondary-data-lime)',
      'var(--color-secondary-data-candy)'
    ];
  }

  const theme = {
    legends: {
      text: {
        fontSize: '0.75rem',
        lineHeight: '1rem',
        fontFamily: 'var(--zurich-font-family-default)'
      }
    },
    axis: {
      legend: {
        text: {
          fontSize: '0.875rem',
          fontWeight: '600',
          fontFamily: 'var(--zurich-font-family-default)'
        }
      },
      ticks: {
        text: {
          fontSize: '0.75rem',
          fontFamily: 'var(--zurich-font-family-default)'
        }
      }
    }
  };

  const getLegendLabels = ():
    | Array<{ id: string; label: string; fill: string }>
    | undefined => {
    return (
      legend?.labels &&
      Object.entries(legend?.labels).map(([key, value], index) => {
        return { id: key, label: value, fill: colors[index] };
      })
    );
  };

  return (
    <div style={{ height: height || '100vh', width: width || '100vw' }}>
      <ResponsiveBar
        data={data}
        indexBy={indexBy}
        keys={keys}
        margin={
          layout === 'horizontal'
            ? { top: 10, right: 10, bottom: 65, left: 65 }
            : { top: 45, right: 10, bottom: 65, left: 70 }
        }
        padding={0.6}
        valueScale={{ type: 'linear' }}
        colors={colors}
        axisBottom={{
          tickPadding: 10,
          legend: legend?.bottomAxis,
          legendPosition: 'middle',
          legendOffset: 55
        }}
        axisLeft={{
          tickPadding: 10,
          legend: legend?.leftAxis,
          legendPosition: 'middle',
          legendOffset: -60
        }}
        enableLabel={false}
        layout={layout}
        legends={[
          {
            data: getLegendLabels(),
            dataFrom: 'keys',
            anchor: 'top-left',
            direction: 'row',
            justify: false,
            translateX: -60,
            translateY: layout === 'horizontal' ? -5 : -40,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            symbolSize: 10,
            symbolShape: 'circle'
          }
        ]}
        theme={theme}
        role="application"
        ariaLabel="Bar chart"
      ></ResponsiveBar>
    </div>
  );
};
